import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex: 1;
`;

export default Container;
